//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: [Number,String],
      defalut: "",
    },
    isShowDays: {
      type: Boolean,
      defalut: false,
    },
  },
  model: {
    prop: "value",
    event: "on-sync",
  },
  data() {
    return {
      days: "00",
      hours: "00",
      minutes: "00",
      seconds: "00",
      countdown: "", // 设置初始倒计时时间
      timer: null, // 用于存储计时器对象
    };
  },
  watch: {
    value: {
      handler(v) {
        this.countdown = v;
      },
      deep: true,
      immediate: true,
    },
    countdown(v) {
      this.$emit("on-sync", v);
    },
  },
  mounted() {
    this.startCountdown();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    startCountdown() {
      this.timer = setInterval(() => {
        const now = Date.now();
        const end = new Date(this.countdown).getTime();
        const diff = end - now;
        if (diff <= 0) {
          clearInterval(this.timer);
          // 倒计时结束
          this.$emit("countdownDinished");
          return;
        }
        // 计算剩余时间
        let days = "",
          hours = "",
          minutes = "",
          seconds = "";
        days = Math.floor(diff / 1000 / 60 / 60 / 24);
        if (days > 0 && !this.isShowDays) {
          hours = Math.floor((diff / 1000 / 60 / 60) % 24) + days * 24;
        } else {
          hours = Math.floor((diff / 1000 / 60 / 60) % 24);
        }
        minutes = Math.floor((diff / 1000 / 60) % 60);
        seconds = Math.floor((diff / 1000) % 60);
        // 补零
        this.days = days.toString().padStart(2, "0");
        this.hours = hours.toString().padStart(2, "0");
        this.minutes = minutes.toString().padStart(2, "0");
        this.seconds = seconds.toString().padStart(2, "0");
      }, 1000);
    },
  },
};
